import { render, staticRenderFns } from "./OurHistory-old.vue?vue&type=template&id=13ca0287&"
import script from "./OurHistory-old.vue?vue&type=script&lang=js&"
export * from "./OurHistory-old.vue?vue&type=script&lang=js&"
import style0 from "./OurHistory-old.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports